import { OverseaDirectBanner } from '../components/OverseaDirectBanner';
import { useOverseaDirectBannerService } from '../services/useOverseaDirectBannerService';

export const OverseaDirectBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { oversea_direct_banner_image_url } = useOverseaDirectBannerService();

  if (!oversea_direct_banner_image_url) {
    return null;
  }
  return <OverseaDirectBanner image_url={oversea_direct_banner_image_url} />;
};
